import React, { useState } from "react";
import { LightIcon, DarkIcon } from "./atoms";
import { ZigSwitchLightDarkContainer } from "./styles";
import { useTheme } from "@mui/material";

export function ZigSwitchLightDark() {
  const theme = useTheme();
  const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem("themeMode") !== "light");

  function handleThemeChange() {
    setIsDarkMode(!isDarkMode);
    localStorage.setItem("themeMode", isDarkMode ? "light" : "dark");

    window.dispatchEvent(new Event("themeChange"));
  }

  return (
    <ZigSwitchLightDarkContainer onClick={handleThemeChange}>
      <DarkIcon color={isDarkMode ? theme.palette.green : "currentColor"} />
      {"/"}
      <LightIcon color={isDarkMode ? "currentColor" : theme.palette.green} />
    </ZigSwitchLightDarkContainer>
  );
}
